import { Component, OnInit, Input } from '@angular/core';
import {
  IDates,
  IOdbBillCategoryDetailSection,
  IOdbBillCategoryDetailSectionItem,
  coverService,
  OdbCoverDetailDivisionType,
} from '@dch/billing-business-logic';
import { TranslationService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-odb-category-section-or-item-variant-one',
  templateUrl: './odb-category-section-or-item-variant-one.component.html',
  standalone: false,
})
export class OdbCategorySectionOrItemVariantOneComponent implements OnInit {
  @Input() section?: IOdbBillCategoryDetailSection;
  @Input() item?: IOdbBillCategoryDetailSectionItem;
  @Input() categoryDetailValidFor?: IDates;
  @Input() categoryType?: OdbCoverDetailDivisionType;

  title?: string;
  subtitle?: string;
  amount?: string;

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.setSectionOrItemData();
  }

  setSectionOrItemData() {
    const { title, subtitle, amount } = coverService.getSectionOrItemData(
      this.section ?? this.item,
      this.categoryDetailValidFor,
      this.translationService.getTranslatedValueFor.bind(
        this.translationService
      )
    );
    this.title = title;
    this.subtitle = subtitle;
    this.amount = amount;
  }
}
